<template>
    <div class="space-y-4 max-h-[40vh] overflow-auto pr-2">
      <h2 class="text-xl font-bold text-center">Rate Your Experience</h2>
  
      <div class="flex flex-col gap-4">
        <div
          v-for="(order, index) in rateOrders"
          :key="index"
          class="inline-flex gap-4 items-center w-full h-20 sm:h-20 border bg-white rounded-lg shadow p-2"
        >
          <!-- Logo -->
          <div class="ml-3 sm:w-16 sm:h-16 w-11 h-11 rounded-lg overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
            <NuxtImg
              :src="useSecureImage(order.provider.images.thumbnail)"
              class="w-full h-full object-cover"
              @error="setDefaultImage"
              alt="Provider Image"
              title="Provider Image"
            />
          </div>
  
          <!-- Text -->
          <div class="flex-1 flex flex-col justify-between sm:pl-4 pl-0">
            <p class="text-gray-700 font-semibold sm:text-sm text-xs">Rate Your Order Experience</p>
            <div class="inline-flex items-center gap-1">
              <p class="text-gray-700 font-semibold sm:text-sm text-xs">
                {{ order.provider.name.length > 10 ? order.provider.name.slice(0, 10) + '...' : order.provider.name }}
              </p>
              <p class="text-xs sm:text-sm text-gray-600">{{ order?.message?.order?.items?.length }} item(s)</p>
            </div>
          </div>
  
          <!-- Button -->
          <div class="flex flex-col justify-between items-center">
            <UButton color="primary" size="xs" label="Rate" block @click="handleRate(order)" class="focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"/>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
import {V3ModalComponent, V3PopupComponent} from "#components";
const emit = defineEmits(['success', 'close']);
const props = defineProps(['data']);
const rateOrders = props.data
const slideover = useSlideover();
const modal = useModal();
const { isMobile } = useDevice();
const runtimeConfig = useRuntimeConfig() 
const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}
const auth = useAuth();
const { gtag } = useGtag();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };
const handleRate = (order) => {
  if (isMobile) {
    slideover.open(V3PopupComponent, {
     component: "ratingForm",
     data: {orderData: order},
     onSuccess: () => {
      window.location.reload();
      slideover.close();
     },
     onClose: slideover.close,
    });
  } else {
    modal.open(V3ModalComponent, {
      component: "ratingForm",
      data: {orderData: order},
      onSuccess: () => {
        window.location.reload();
        modal.close();
      },
      onClose: modal.close,
    });
  }
  gtag("event", "cta_event", {
    action: "click",
    cta_name: "rating_cta_clicked",
    ...userData,
  });
}
</script>